export default __webpack_public_path__ + "static/media/sa.5c0e0f31.jpg";